import { render, staticRenderFns } from "./TierRemove.vue?vue&type=template&id=97b90c44&scoped=true&"
import script from "./TierRemove.vue?vue&type=script&lang=js&"
export * from "./TierRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b90c44",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97b90c44')) {
      api.createRecord('97b90c44', component.options)
    } else {
      api.reload('97b90c44', component.options)
    }
    module.hot.accept("./TierRemove.vue?vue&type=template&id=97b90c44&scoped=true&", function () {
      api.rerender('97b90c44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Agent/components/Tier/TierRemove.vue"
export default component.exports